module.exports = __webpack_public_path__ + "assets/e7c89fadb02ac5bb5ccd48f14fba45f3.mp4";